import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { RTL_LANGUAGES, LANGUAGE_CONFIG } from '../i18n'

export const useDirection = () => {
  const { i18n } = useTranslation()
  const [direction, setDirection] = useState('ltr')

  useEffect(() => {
    const currentLanguage = i18n.language
    const isRTLLanguage = RTL_LANGUAGES.includes(currentLanguage)
    const newDirection = isRTLLanguage ? 'rtl' : 'ltr'

    setDirection(newDirection)
    document.documentElement.lang = currentLanguage
  }, [i18n.language])

  const languageConfig = LANGUAGE_CONFIG[i18n.language] || LANGUAGE_CONFIG.en

  return {
    direction,
    isRTL: direction === 'rtl',
    isLTR: direction === 'ltr',
    language: i18n.language,
    languageConfig,
  }
}

export const useDirectionalStyle = (ltrStyle, rtlStyle) => {
  const { isRTL } = useDirection()
  return isRTL ? rtlStyle : ltrStyle
}

export const useDirectionalSpacing = (start, end = 0) => {
  const { isRTL } = useDirection()

  if (isRTL) {
    return {
      marginLeft: end,
      marginRight: start,
      paddingLeft: end,
      paddingRight: start,
    }
  }

  return {
    marginLeft: start,
    marginRight: end,
    paddingLeft: start,
    paddingRight: end,
  }
}

export default useDirection
